import { TextField } from "@mui/material";
import SortableEntryWrapper from "./SortableEntryWrapper";

interface TermLengthEntryProps {
  id: string;
  index: number;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onRemove: () => void;
  canRemove: boolean;
  autoFocus?: boolean;
}

export default function TermLengthEntry({
  id,
  index,
  value,
  onChange,
  onRemove,
  canRemove,
  autoFocus,
}: TermLengthEntryProps) {
  return (
    <SortableEntryWrapper id={id} onRemove={onRemove} canRemove={canRemove}>
      <TextField
        label={`Mortgage Term ${index + 1} (years)`}
        type="number"
        value={value ?? ""}
        onChange={(e) => {
          const v = e.target.value;
          if (v === "") {
            onChange(undefined);
            return;
          }
          const parsed = parseInt(v, 10);
          onChange(Number.isNaN(parsed) ? undefined : Math.max(1, parsed));
        }}
        slotProps={{ htmlInput: { min: 1, max: 83 } }}
        fullWidth
        margin="none"
        required
        autoFocus={autoFocus}
      />
    </SortableEntryWrapper>
  );
}
